import { render, staticRenderFns } from "./create_old.vue?vue&type=template&id=2e0c59c2&"
import script from "./create_old.vue?vue&type=script&lang=js&"
export * from "./create_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports